export default __webpack_public_path__ + "static/media/clientlogomerck1.8190be81.svg";